import type { ClassValue } from "clsx";
import clsx from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Custom @theme font-size tokens MUST be registered here — otherwise
// tailwind-merge treats e.g. `text-copy` as a text COLOR and drops it
// when merged with an actual color like `text-black`. Note: a font-size
// class also conflicts with `leading-*`, so always put the size token
// BEFORE any leading utility in the cn() argument order.
// Custom @theme spacing tokens likewise: without `spacing` registration
// tailwind-merge can't tell that e.g. `p-medium` conflicts with `p-35`.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ["medium"],
    },
    classGroups: {
      "font-size": [
        { text: ["title", "h2", "h3", "detail", "lead", "copy", "small"] },
      ],
    },
  },
});

export default function (...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
